import * as React from "react";
import {useNavigate} from "react-router-dom";
import "./styles.scss";
import {JSONCensus} from "../../../processes/massive_actions/CensusCooler/data/models/JSONCensus";
import {getFormattedDate} from "../../../ReadAndWrite/ReadAndWrite/utils";

interface CensusListElementProps {
    census: JSONCensus
}

export const CensusListElement: React.FC<CensusListElementProps> = ({census}) => {
    const navigate = useNavigate();

    const showCensusDetails = () => {
        navigate("/" + census.guid, {state: census, relative: "route"})
    }

    return (
        <div
            key={census.guid + " - element"}
            className={"census-list-element"}
            onClick={showCensusDetails}
        >
            <p
                className="data"
            >{getFormattedDate({dateToFormat: census?.createdAt})}</p>
            <p className="user">
                {census?.username}
            </p>
        </div>
    )
}